/**
 * DevExtreme (esm/__internal/core/r1/runtime/inferno/re_render_effect.js)
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import { rerender as reRender } from "inferno";
import { InfernoEffect } from "./effect";
export const createReRenderEffect = () => new InfernoEffect(() => {
  reRender();
}, []);